import styled from 'styled-components'

import { headerColorRed } from '@Constants/ThemeColor'

export const HeaderWrapper = styled.div(
  (props) => `
    padding: ${props.padding || '1rem 5rem'};
    display: flex;
    align-content: center;
    align-items: center;
    justify-content: space-between;
    
    .iconWrapper{
      display: flex;
      align-items: center;
      .width5rem{
        width: 5rem;
      }
    }
  `
)

export const TitleWrapper = styled.div(
  (props) => `
    color: ${headerColorRed};
    text-align: center;

    @media (min-width: 765px) and (max-width: 920px) {
      font-size: 0.7rem;
    }
  `
)

export const HeaderLeftPannal = styled.div`
  display: flex;
  align-items: center;

  .img1_azadi_year_logo {
    width: 10.5rem;
    height: 4.4rem;
  }
`
